import { Flex, Switch, Typography, Checkbox } from 'antd'
import { CheckOutlined, CloseOutlined } from '@ant-design/icons'
import { colorTextGray1, success } from 'src/app/themes/primaryThemeDefault'
import './index.scss'
import { useTranslation } from 'react-i18next'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { Controller } from 'react-hook-form'

interface IOption {
  id: number
  name?: string
  allowBankUsersToEditEmailNotifications?: boolean
  createdBy?: string | null
  createdOn?: string | null
  emailMessage?: string | null
  emailSubject?: string | null
  emailType?: string | null
  tenantId?: string | null
  updatedBy?: string | null
  updatedOn?: string | null
  userNotificationTypeAssignments?: string | null
}

interface IProps {
  title: string
  listSwitchers: Array<IOption>
  isTurnOnFirst?: boolean
  data?: any
  replace?: any
  control: any
  setValue: any
  trigger: any
  name: string
  defaultPermission: string
}

const PermissionSwitchers = (props: IProps) => {
  const { t } = useTranslation()
  const { isTurnOnFirst, data, replace, control, setValue, trigger, name, listSwitchers, defaultPermission } = props
  const formatData = data?.map((item: any) => item?.permissionId)

  const handleCheckOnchange = (e: CheckboxChangeEvent, field: any) => {
    field.onChange(e)
    if (e.target.checked) {
      setValue(
        name,
        listSwitchers?.map((item: any) => ({ permissionId: item?.id })),
      )
    } else {
      setValue(name, [{ permissionId: defaultPermission }])
    }
    trigger(name)
  }

  return (
    <Flex vertical style={{ marginBottom: 24 }}>
      <Flex justify='space-between' align='center'>
        <Typography.Paragraph style={{ marginBottom: 12 }} className='switcher-title'>
          {props.title}
        </Typography.Paragraph>
        <Controller
          name='selectAllPermissions'
          control={control}
          render={({ field }) => (
            <Checkbox
              {...field}
              checked={field.value}
              style={{ marginBottom: 12 }}
              onChange={(e: CheckboxChangeEvent) => {
                handleCheckOnchange(e, field)
              }}
            >
              {t('UserRoles:selectAllPermissions')}
            </Checkbox>
          )}
        />
      </Flex>
      <Flex
        vertical
        style={{
          padding: '8px 0px',
          border: `1px solid ${colorTextGray1} `,
          borderRadius: '16px',
        }}
      >
        <Flex vertical gap={25} style={{ padding: '13px 24px 24px 24px', height: 250, overflowY: 'scroll' }}>
          {props.listSwitchers?.map((item, idx) => {
            return (
              <Flex gap={12} key={`${item?.id}`}>
                <Switch
                  style={formatData?.includes(item?.id) ? { background: success } : {}}
                  checkedChildren={<CheckOutlined />}
                  unCheckedChildren={<CloseOutlined />}
                  onChange={(e) => {
                    const tmp = formatData ?? []
                    const SetTmp = new Set(tmp)
                    if (SetTmp.has(item?.id)) {
                      SetTmp.delete(item?.id)
                    } else {
                      SetTmp.add(item?.id)
                    }
                    replace(Array.from(SetTmp)?.map((item: any) => ({ permissionId: item })))

                    if (Array.from(SetTmp)?.length === listSwitchers?.length) {
                      setValue('selectAllPermissions', true)
                    } else {
                      setValue('selectAllPermissions', false)
                    }
                  }}
                  checked={formatData?.includes(item?.id)}
                  disabled={isTurnOnFirst ? idx === 0 : false}
                  defaultChecked={formatData?.includes(item?.id)}
                />
                <Typography>{item?.name ?? item?.emailType}</Typography>
              </Flex>
            )
          })}
        </Flex>
      </Flex>
    </Flex>
  )
}

export default PermissionSwitchers
